<template>
  <div class="data-wrapper-core">
    <template v-if="!hideHeader">
      <h3>
        Kunden ( {{ customerLength }} gesamt | {{ amountArchived }} archiviert |
        <span :style="{ color: amountInactive ? 'red' : '' }"
          >{{ amountInactive }} inaktiv )</span
        >
      </h3>
    </template>
    <p v-else class="customer-counts">
      {{ customerLength }} gesamt | {{ amountArchived }} archiviert |
      <span :style="{ color: amountInactive ? 'red' : '' }">{{ amountInactive }} inaktiv</span>
    </p>
    <div class="customer-data-table-wrapper">
      <v-text-field
        class="customer-data-search"
        flat
        v-model="search"
        label="Suche"
        prepend-inner-icon="mdi-magnify"
        variant="outlined"
        density="compact"
        hide-details
        single-line
        rounded="lg"
      ></v-text-field>
      <v-data-table
        class="content-data-table"
        density="compact"
        :headers="headersFiltered"
        :items="filteredCustomers"
        :search="search"
      >
        <template v-slot:item="{ item }">
          <tr class="v-table-row" @click="openCustomerDialog(item)">
            <td>{{ item.name }}</td>
            <td>{{ formatDate(item.createdAt) }}</td>
          </tr>
        </template>
      </v-data-table>
      <v-expansion-panels class="mt-4">
        <v-expansion-panel>
          <v-expansion-panel-title>
            Inaktive und archivierte Kunden
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <v-data-table
              class="content-data-table"
              density="compact"
              :headers="headers"
              :items="archivedInactiveCustomers"
              :search="search"
            >
              <template v-slot:item="{ item }">
                <tr class="v-table-row" @click="openCustomerDialog(item)">
                  <td>{{ item.name }}</td>
                  <td>{{ item.archived }}</td>
                  <td>{{ item.inactive }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
      <CustomerDialog
        v-if="selectedCustomer._id"
        :customerId="selectedCustomer._id"
      ></CustomerDialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import CustomerDialog from "../customerDialog/CustomerDialog.vue";

export default {
  components: {
    CustomerDialog,
  },
  props: {
    agency: {
      type: Object,
      required: true,
    },
    hideHeader: { type: Boolean, default: false },
  },
  data() {
    return {
      customerLength: this.agency.customers.length,
      search: "",
      headersFiltered: [
        { key: "name", title: "Name", sortable: true },
        { key: "createdAt", title: "Erstelldatum", sortable: true },
      ],
      headers: [
        { key: "name", title: "Name", sortable: true },
        { key: "archived", title: "Archiviert", sortable: true },
        { key: "inactive", title: "Inaktiv", sortable: true },
      ],
      amountArchived: 0,
      amountInactive: 0,
      selectedCustomer: {},
    };
  },
  computed: {
    ...mapState("agency", ["customers"]),
    filteredCustomers() {
      return this.customers.filter(
        (customer) => !customer.archived && !customer.inactive
      );
    },
    archivedInactiveCustomers() {
      return this.customers.filter(
        (customer) => customer.archived || customer.inactive
      );
    },
  },
  methods: {
    ...mapMutations("customer", ["setCustomerDialog"]),
    ...mapMutations("agency", ["setAgencyDialog"]),
    filterCustomers() {
      this.amountArchived = this.customers.filter(
        (customer) => customer.archived
      ).length;
      this.amountInactive = this.customers.filter(
        (customer) => customer.inactive
      ).length;
    },
    openCustomerDialog(item) {
      this.$store.commit("customer/setCustomerDialog", true);
      this.$store.commit("agency/resetAgencyDialog");
      this.$router.push({ name: "customer", params: { customerId: item._id } });
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("de-DE");
    },
  },
  watch: {
    agency: {
      handler() {
        this.customerLength = this.agency.customers.length;
      },
      deep: true,
    },
    customers: {
      handler() {
        this.filterCustomers();
      },
      deep: true,
    },
  },
  mounted() {
    this.filterCustomers();
  },
};
</script>

<style lang="scss" scoped>
.data-wrapper-style {
  margin: 12px 0;
  background-color: #f9fafb;
  padding: 8px;
  border-radius: 12px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
  max-height: 648px; //fits 20 customers without scrolling
  overflow-y: auto;
}

.customer-data-search {
  margin-bottom: 8px;
  border-radius: 12px;
}

.v-table {
  background-color: #f9fafb;
}

.v-table-row {
  cursor: pointer;
}

.agency-dialog-customer {
  margin: 8px 0;
}

.customer-counts {
  margin: 0 0 12px 0;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.7);
}
</style>

